<!--
 * @Description: 客户激活表单信息
-->
<template>
  <a-form ref="formRef" name="advanced_search" :model="form">
    <dc-layout-card :title="t('common.baseTabs')">
      <dc-form-item
          name="customerName"
          :label="t('custom.customerName')"
          :rules="{
          message: t('common.pleaseInput'),
          required: true
        }"
      >
        <CosInput v-model:value="form.customerName" :maxlength="50" :view="formItemView" />
      </dc-form-item>
      <dc-form-item
          :label="t('custom.customerNumber')"
          name="customerNumber"
          :rules="{
                message: t('common.pleaseSelect'),
                required: true
              }"
      >
        <SerialSelect
            v-model:value="form.customerNumber"
            :cosId="route.query.cosId"
            :view="formItemView"
            :requiredCosId="true"
        />
      </dc-form-item>
      <dc-form-item
        name="customerWebsite"
        :label="t('custom.officialWeb')"
        :rules="{
               message: t('common.pleaseInput'),
               required: true
             }">
        <CosInput
            v-model:value.trim="form.customerWebsite"
            :maxlength="200"
            :disabled="disabled"
            :view="formItemView"
        />
      </dc-form-item>
      <dc-form-item
        name="registerEmail"
        :label="t('custom.regEmail')"
        :rules="{
              message: t('common.pleaseInput'),
              required: true
             }">
        <CosInput
            v-model:value.trim="form.registerEmail"
            :maxlength="200"
            :disabled="disabled"
            :view="formItemView"
        />
      </dc-form-item>
      <dc-form-item
        v-if="form.applyNo"
        name="applyNo"
        :label="t('custom.申请单号')"
        :rules="{ required: true }"
      >
        <CosInput
          v-model:value.trim="form.applyNo"
          disabled
          :view="formItemView"
        />
      </dc-form-item>
    </dc-layout-card>
    <dc-layout-card :title="t('custom.业务需求')">
      <dc-form-item
        :label="t('custom.业务类型')"
        :name="['business', 'businessTypeSelect']"
        :rules="{
          message: t('common.pleaseSelect'),
          required: true
        }"
      >
        <ParamCodesSelect
          v-model:value="form.business.businessTypeSelect"
          :options="paramCodeData.ofbu_business_type"
          :disabled="disabled"
          :view="formItemView"
          allowClear
        />
      </dc-form-item>
      <dc-form-item
          :label="t('custom.区域仓')"
          :name="['business', 'regionalWarehouse']"
          :rules="{
          message: t('common.pleaseSelect'),
          required: true
        }"
      >
        <ParamCodesSelect
            v-model:value="form.business.regionalWarehouse"
            :options="paramCodeData.ofbu_demand_info"
            :disabled="disabled"
            :view="formItemView"
            allowClear
            mode="multiple"
        />
      </dc-form-item>
    </dc-layout-card>
    <dc-layout-card :title="t('custom.报价')" :span="6">
      <template #subTitle v-if="!formItemView">
        <a-button type="primary" ghost @click="handleAddCol(form.business.quotationInfo.details)">{{ t('btn.add') }}</a-button>
      </template>
      <dc-form-item
          :label="t('custom.价格类型')"
          :name="['business', 'quotationInfo', 'quotationType']"
          :rules="{
          message: t('common.pleaseSelect'),
          required: true
        }"
      >
        <ParamCodesSelect
            v-model:value="form.business.quotationInfo.quotationType"
            :options="paramCodeData.ofbu_quotation_type"
            :disabled="disabled"
            :view="formItemView"
            allowClear
        />
      </dc-form-item>
      <dc-form-item
          v-if="quotationAndBusinessChange"
          :name="['business', 'quotationInfo', 'fulfillmentRatesVersion']"
          :label="t('custom.仓储报价版本')"
          :rules="{
              message: t('common.pleaseInput'),
              required: quotationAndBusinessChange
            }"
      >
        <CosInput
            v-model:value.trim="form.business.quotationInfo.fulfillmentRatesVersion"
            :maxlength="200"
            :disabled="disabled"
            :view="formItemView"
        />
      </dc-form-item>
      <dc-form-item
          v-if="quotationAndBusinessChange"
          :name="['business', 'quotationInfo', 'shippingRatesVersion']"
          :label="t('custom.尾程报价版本')"
          :rules="{
              message: t('common.pleaseInput'),
              required: quotationAndBusinessChange
            }"
      >
        <CosInput
            v-model:value.trim="form.business.quotationInfo.shippingRatesVersion"
            :maxlength="200"
            :disabled="disabled"
            :view="formItemView"
        />
      </dc-form-item>
      <dc-form-item
        v-if="form.business.quotationInfo.quotationType === 3469"
        :name="['business', 'quotationInfo', 'priceDocuments']"
        :label="t('custom.报价策略')"
        :rules="{ required: form.business.quotationInfo.quotationType === 3469, message: t('common.pleaseInput') }"
      >
        <CosInput
            v-model:value.trim="form.business.quotationInfo.priceDocuments"
            :maxlength="200"
            :disabled="disabled"
            :view="formItemView"
        />
      </dc-form-item>
      <MultipleItem :view="formItemView" v-if="quotationAndBusinessChange">
        <template v-for="(item, index) in form.business.quotationInfo.details" :key="index">

          <a-col :span="24">
           <p style="font-weight: bold;padding-bottom:4px">{{ `${t('custom.区域仓')}${index+1}` }}</p>
          </a-col>
          <dc-form-item
              :label="t('custom.区域仓')"
              :name="['business', 'quotationInfo', 'details', index, 'regionalWarehouse']"
              :span="3"
              :rules="{
              message: t('common.pleaseSelect'),
              required: true
            }"
          >
            <ParamCodesSelect
                v-model:value="item.regionalWarehouse"
                :options="paramCodeData.ofbu_demand_info"
                :disabled="disabled"
                :view="formItemView"
                allowClear
            />
          </dc-form-item>
          <dc-form-item :name="['business', 'quotationInfo', 'details', index, 'subWarehouseCode']" :label="t('custom.物理仓')" :span="3">
            <template #label>
              <a-tooltip placement="topLeft" :overlayStyle="{ maxWidth: '800px' }">
                <template #title>
                  <p>Warehouse Management Team will confirm in OA</p>
                </template>
                <span>{{t('custom.物理仓')}}</span>
                <exclamation-circle-outlined style="margin-left: 2px; font-size: 14px" />
              </a-tooltip>
            </template>
            <CosInput
                v-model:value.trim="item.subWarehouseCode"
                :maxlength="200"
                disabled
                ignorePlaceHolder
                :view="formItemView"
            />
          </dc-form-item>
          <dc-form-item
              :name="['business', 'quotationInfo', 'details', index, 'storageFeeDiscount']"
              :label="t('custom.仓租折扣(%)')"
              :span="3"
              :rules="{
              message: t('common.pleaseInput'),
              required: true
            }">
            <CosInput
                v-model:value.trim="item.storageFeeDiscount"
                :maxlength="200"
                :disabled="disabled"
                :view="formItemView"
            />
          </dc-form-item>
          <dc-form-item
              :name="['business', 'quotationInfo', 'details', index, 'handingFeeDiscount']"
              :label="t('custom.操作费折扣(%)')"
              :span="3"
              :rules="{
              message: t('common.pleaseInput'),
              required: true
            }">
            <CosInput
                v-model:value.trim="item.handingFeeDiscount"
                :maxlength="200"
                :disabled="disabled"
                :view="formItemView"
            />
          </dc-form-item>
          <dc-form-item
              :name="['business', 'quotationInfo', 'details', index, 'shippingFeeDiscount']"
              :label="t('custom.尾程折扣(%)')"
              :span="3"
              :rules="{
              message: t('common.pleaseInput'),
              required: true
            }">
            <CosInput
                v-model:value.trim="item.shippingFeeDiscount"
                :maxlength="200"
                :disabled="disabled"
                :view="formItemView"
            />
          </dc-form-item>
          <dc-form-item :name="['business', 'quotationInfo', 'details', index, 'remark']" :label="t('common.remark')" :span="6">
              <CosInput
                  v-model:value="item.remark"
                  :maxlength="2000"
                  :disabled="disabled"
                  :view="formItemView"
              />
          </dc-form-item>
          <dc-form-item v-if="
                        !formItemView &&
                        form.business.quotationInfo.details &&
                        form.business.quotationInfo.details.length > 1
                " :span="3">
            <a-button
              type="text"
              danger
              style="padding: 0 0 0 12px"
              @click="handleDelCol(form.business.quotationInfo.details,index)"
            >{{ t('btn.del') }}</a-button
            >
          </dc-form-item>
        </template>
      </MultipleItem>
      <dc-form-item :label="t('custom.客户报价/竞对报价')" :name="['business', 'quotationInfo', 'competitorPriceDocuments']" :span="24">
        <UploadFile :view="formItemView" v-model:value="form.business.quotationInfo.competitorPriceDocuments" valueType="array" />
      </dc-form-item>
    </dc-layout-card>

    <dc-layout-card :title="t('custom.合同和账期')" :span="6">
      <dc-form-item
          :label="t('custom.服务公司')"
          :name="['business', 'contractInfo', 'serviceCompany']"
          :rules="{
              message: t('common.pleaseSelect'),
              required: true
            }"
      >
        <ParamCodesSelect
            v-model:value="form.business.contractInfo.serviceCompany"
            :options="paramCodeData.ofbu_service_body"
            :disabled="disabled"
            :view="formItemView"
            allowClear
        />
      </dc-form-item>
      <dc-form-item
          :label="t('custom.付款方式')"
          :name="['business', 'contractInfo', 'paymentType']"
          :rules="{
              message: t('common.pleaseSelect'),
              required: true
            }"
      >
        <ParamCodesSelect
            v-model:value="form.business.contractInfo.paymentType"
            :options="paramCodeData.ofbu_payment_type"
            :disabled="disabled"
            :view="formItemView"
            allowClear
        />
      </dc-form-item>
      <dc-form-item
          :label="t('custom.出账周期(天)')"
          :name="['business', 'contractInfo', 'billingTerm']"
          :rules="{
              message: t('common.pleaseSelect'),
              required: true
            }"
      >
        <ParamCodesSelect
            v-model:value="form.business.contractInfo.billingTerm"
            :options="paramCodeData.ofbu_billing_term"
            :disabled="disabled"
            :view="formItemView"
            allowClear
        />
      </dc-form-item>
      <dc-form-item
          v-if="form.business.contractInfo.paymentType === 3504
          || form.business.contractInfo.paymentType === 3473"
          :name="['business', 'contractInfo', 'paymentTerm']"
          :label="t('custom.付款周期(天)')"
          :rules="{
              message: t('common.pleaseInput'),
              required: form.business.contractInfo.paymentType === 3473
            }"
      >
        <CosInput
            v-model:value.trim="form.business.contractInfo.paymentTerm"
            :maxlength="200"
            :disabled="disabled"
            :view="formItemView"
        />
      </dc-form-item>
      <a-col :span="6" v-if="!formItemView && form.business.contractInfo.paymentType === 3504">
        <div class="flex cos-both-form-item">
          <a-form-item
              style="width: 70%"
              :label="t('custom.固定额度')"
              :name="['business', 'contractInfo', 'fixedCredit', 'amount']"
              :rules="{
              message: t('common.pleaseInput'),
              required: true
            }"
          >
            <CosInputNumber
                v-model:value="form.business.contractInfo.fixedCredit.amount"
                :maxlength="15"
                :min="0"
                :controls="false"
                :view="formItemView"
                cosType="money"
                :formatter="(inputValue) => `${inputValue}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                :parser="(inputValue) => inputValue.replace(/\$\s?|(,*)/g, '')"
            />
          </a-form-item>
          <a-form-item
              label="fixedCreditCurrency"
              style="width: 30%"
              :name="['business', 'contractInfo', 'fixedCredit', 'currency']"
              class="hide-label"
              :rules="{
              message: t('common.pleaseSelect'),
              required: true
            }"
          >
            <ParamCodesSelect
                :options="paramCodeData.ofbu_currency"
                v-model:value="form.business.contractInfo.fixedCredit.currency"
                :view="formItemView"
            />
          </a-form-item>
        </div>
      </a-col>
      <dc-form-item
        v-if="formItemView && form.business.contractInfo.paymentType === 3504"
        :label="t('custom.固定额度')"
        :name="['business', 'contractInfo', 'fixedCredit', 'currency']"
        :rules="{
              message: t('common.pleaseSelect'),
              required: true
            }"
      >
        <ParamCodesSelect
          :cosBeforeDes="form.business.contractInfo.fixedCredit.amount?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
          :options="paramCodeData.ofbu_currency"
          v-model:value="form.business.contractInfo.fixedCredit.currency"
          :view="formItemView"
        />
      </dc-form-item>
      <a-col :span="6" v-if="!formItemView">
        <div class="flex cos-both-form-item">
          <a-form-item
              style="width: 70%"
              :label="t('custom.系统注册费')"
              :name="['business', 'contractInfo', 'registrationFee', 'amount']"
              :rules="{
              message: t('common.pleaseInput'),
              required: true
            }"
          >
            <CosInputNumber
                v-model:value="form.business.contractInfo.registrationFee.amount"
                :maxlength="15"
                :min="0"
                :controls="false"
                :view="formItemView"
                cosType="money"
                :formatter="(inputValue) => `${inputValue}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                :parser="(inputValue) => inputValue.replace(/\$\s?|(,*)/g, '')"
            />
          </a-form-item>
          <a-form-item
              label="registrationFeeCurrency"
              style="width: 30%"
              :name="['business', 'contractInfo', 'registrationFee', 'currency' ]"
              class="hide-label"
              :rules="{
              message: t('common.pleaseSelect'),
              required: true
            }"
          >
            <ParamCodesSelect
                :options="paramCodeData.ofbu_currency"
                v-model:value="form.business.contractInfo.registrationFee.currency"
                :view="formItemView"
            />
          </a-form-item>
        </div>
      </a-col>
      <dc-form-item
        v-else
        :label="t('custom.系统注册费')"
        :name="['business', 'contractInfo', 'registrationFee', 'currency']"
        :rules="{
              message: t('common.pleaseSelect'),
              required: true
            }"
      >
        <ParamCodesSelect
          :cosBeforeDes="form.business.contractInfo.registrationFee.amount?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
          :options="paramCodeData.ofbu_currency"
          v-model:value="form.business.contractInfo.registrationFee.currency"
          :view="formItemView"
        />
      </dc-form-item>
      <a-col :span="6" v-if="!formItemView">
        <div class="flex cos-both-form-item">
          <a-form-item
              style="width: 70%"
              :label="t('custom.系统管理月费')"
              :name="['business', 'contractInfo', 'monthlyMaintenanceFee', 'amount']"
              :rules="{
              message: t('common.pleaseInput'),
              required: true
            }"
          >
            <CosInputNumber
                v-model:value="form.business.contractInfo.monthlyMaintenanceFee.amount"
                :maxlength="15"
                :min="0"
                :controls="false"
                :view="formItemView"
                cosType="money"
                :formatter="(inputValue) => `${inputValue}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                :parser="(inputValue) => inputValue.replace(/\$\s?|(,*)/g, '')"
            />
          </a-form-item>
          <a-form-item
              label="monthlyMaintenanceFeeCurrency"
              style="width: 30%"
              :name="['business', 'contractInfo', 'monthlyMaintenanceFee', 'currency']"
              class="hide-label"
              :rules="{
              message: t('common.pleaseSelect'),
              required: true
            }"
          >
            <ParamCodesSelect
                :options="paramCodeData.ofbu_currency"
                v-model:value="form.business.contractInfo.monthlyMaintenanceFee.currency"
                :view="formItemView"
            />
          </a-form-item>
        </div>
      </a-col>
      <dc-form-item
        v-else
        :label="t('custom.系统管理月费')"
        :name="['business', 'contractInfo', 'monthlyMaintenanceFee', 'currency']"
        :rules="{
              message: t('common.pleaseSelect'),
              required: true
            }"
      >
        <ParamCodesSelect
          :cosBeforeDes="form.business.contractInfo.monthlyMaintenanceFee.amount?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
          :options="paramCodeData.ofbu_currency"
          v-model:value="form.business.contractInfo.monthlyMaintenanceFee.currency"
          :view="formItemView"
        />
      </dc-form-item>
      <dc-form-item
          :label="t('custom.客户特殊服务')"
          :name="['business', 'contractInfo', 'additionalServices']"
          :rules="{
              message: t('common.pleaseSelect'),
              required: true
            }"
      >
        <ParamCodesSelect
            v-model:value="form.business.contractInfo.additionalServices"
            :options="paramCodeData.ofbu_service_demand"
            :disabled="disabled"
            :view="formItemView"
            allowClear
            mode="multiple"
        />
      </dc-form-item>
      <dc-form-item
          :name="['business', 'contractInfo', 'legalSystemApplicationNo']"
          :label="t('custom.法务流程编码')"
          :rules="{
              message: t('common.pleaseSelect'),
              required: true
            }">
        <CosInput
            v-model:value.trim="form.business.contractInfo.legalSystemApplicationNo"
            :maxlength="200"
            :disabled="disabled"
            :view="formItemView"
        />
      </dc-form-item>
      <a-col :span="24" />
      <dc-form-item :label="t('common.remark')" :span="12">
        <CosTextarea v-model:value="form.remark" :maxlength="2000" :view="formItemView" />
      </dc-form-item>
    </dc-layout-card>
    <dc-layout-card v-if="formItemView" :title="t('custom.审核记录')" :span="6">
      <cos-table
          :columns="reviewHistoryColumns"
          style="padding:0 6px 6px 6px"
          :data-source="props.reviewHistory"
          serial
          rowKey="nodeId"
          tableId="accountActivationReviewHistory"
          :needPage="false"
          :dynamicColumnSetting="false"
      >

      </cos-table>
    </dc-layout-card>
  </a-form>
  <cos-footer-button
      v-if="!disabled"
      v-model:value="form"
      :resetValue="resetValue"
      :formRef="formRef"
      :loading="loading"
      :disabled="disabled"
  >
    <a-button v-if="review !== '1'" @click="handleSaveToDraft" :loading="loading" s>{{ $t('btn.saveOaDraft') }}</a-button>
    <a-button type="primary" @click="handleSubmit" :loading="loading">{{t('btn.save&Submit') }}</a-button>
  </cos-footer-button>
</template>
<script setup lang="ts">
import { computed, onMounted, watch, ref, PropType, reactive } from 'vue'
import MultipleItem from '@/components/CosViewContent/multipleItem.vue'
import { listByParamCodes } from '@/api/common'
import type { PotentialItem } from '@/typings/api/customerCenter'
import { DcConfirm, DcMessage, message } from '@dc-platform/dc-components'
import { useRoute } from 'vue-router'
import { goBack } from '@/hooks/cosRouter'
import { usePermissionStore } from '@/stores/permission'
import { cloneDeep } from 'lodash-es'
import { initObjectVal, paramCodesDataFilter } from '@/utils/index'

import { useI18n } from 'vue-i18n'
import UploadFile from '@/components/UploadFile'
import CosTable from '@/components/CosTable/src/cosTable.vue'
import {
  newClientEvaluationCreate, newClientEvaluationDraft,
  newClientEvaluationEdit
} from '@/api/overseasSales/newClientEvaluation'
import SerialSelect from '@/views/overseasSales/customerCenter/components/serialSelect.vue'
import CosInput from '@/components/Antd/CosInput/index.vue'
import { ExclamationCircleOutlined } from '@ant-design/icons-vue'
const { t } = useI18n()
const permissionStore = usePermissionStore()
const permissionBtn = ref<any[]>(permissionStore.permission)
const route = useRoute()
const initForm = reactive<any>({
  business: {
    businessType: [],
    quotationInfo: { details: [{}] },
    contractInfo: { fixedCredit: {}, registrationFee: {}, monthlyMaintenanceFee: {} }
  },
  contact: {},
  visitAddress: [{}]
})
const resetValue = ref(cloneDeep(initForm))
const loading = ref(false)
const reviewHistoryColumns = computed(() => [
  {
    title: t('common.operator'),
    dataIndex: 'operatorName'
  },
  {
    title: t('common.operatorDate'),
    dataIndex: 'createTime',
    type: 'time'
  },
  {
    title: t('clue.当前审核意见'),
    dataIndex: 'processSuggject',
    ellipsis: false
  }
])
const cosId = computed(() => form.value.cosId)
const form = ref<any>(cloneDeep(initForm))
const props = defineProps({
  disabled: {
    type: Boolean,
    default: true
  },
  reviewHistory: {
    type: Array
  },
  data: {
    type: Object as PropType<PotentialItem>,
    default: () => {
      return {
        business: {},
        contact: {}
      }
    }
  },
  permissionPage: {
    type: Object,
    default: () => {
      return {}
    }
  },
  formItemView: {
    type: Boolean
  },
  hideOk: {
    type: Boolean
  }
})
watch(
  () => props.data,
  (v, prev) => {
    if (v) {
      const formVal = v
      initObjectVal(formVal, initForm)
      form.value = cloneDeep(formVal)
      resetValue.value = cloneDeep(formVal)
    }
  },
  { immediate: true }
)
const quotationAndBusinessChange = ref<boolean>(false)
// 当【价格类型】选择为【公布价】且【业务类型】选择为【仓储服务】或【头程+仓储】时
watch(
  () => [form.value.business.quotationInfo.quotationType, form.value.business.businessTypeSelect],
  (newValue, oldValue) => {
    const [quotationType, businessTypeSelect] = newValue
    quotationAndBusinessChange.value = (quotationType === 3468) &&
      (businessTypeSelect === 3438 || businessTypeSelect === 3441)
  },
  { immediate: true, deep: true }
)
watch(
  () => form.value.business.contractInfo?.paymentType,
  (newValue, oldValue) => {
    if (newValue === 3504 || newValue === 3473) {
      if (!form.value.business.contractInfo.paymentTerm) {
        form.value.business.contractInfo.paymentTerm = '10'
      }
    }
  },
  { immediate: true, deep: true }
)
const queryAccountActivationId = computed(() => route.query.accountActivationId as unknown as number)
// 是否是再次提交审核 只要等于1 就是
const review = computed(() => route.query.review as string)
const formRef = ref()
const paramCodeData = ref<any>({
  ofbu_sales_category: [], // 销售品类
  ofbu_product_type: [], // 货物类型
  ofbu_warehouse: [], // 合作海外仓
  ofbu_sale_platform: [], // 在售电商平台
  ofbu_service_demand: [], // 服务需求
  ofbu_payment_type: [], // 付款方式
  ofbu_billing_term: [], // 出账周期
  ofbu_demand_info: [], // 需求海外仓
  ofbu_erp_info: [], // 目前使用ERP
  ofbu_quotation_type: [], // 价格类型
  ofbu_replenish_frequency: [], // 头程补货频次
  ofbu_business_type: [], // 客户业务类型
  ofbu_marketing_activity: [], // 关联市场活动
  ofbu_head_replenish_method: [], // 头程补货方式
  ofbu_area_code: [], // 电话区号
  ofbu_customer_size: [], // 客户规模
  ofbu_service_body: [], // 服务公司
  ofbu_currency: [] // 币种
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_ofbu',
    paramCodes: [
      'ofbu_sales_category',
      'ofbu_product_type',
      'ofbu_warehouse',
      'ofbu_sale_platform',
      'ofbu_service_demand',
      'ofbu_payment_type',
      'ofbu_billing_term',
      'ofbu_demand_info',
      'ofbu_erp_info',
      'ofbu_quotation_type',
      'ofbu_replenish_frequency',
      'ofbu_business_type',
      'ofbu_marketing_activity',
      'ofbu_head_replenish_method',
      'ofbu_area_code',
      'ofbu_customer_size',
      'ofbu_service_body',
      'ofbu_sign_in_address_label',
      'ofbu_currency'
    ]
  }).then((res) => {
    if (res.code === 200) {
      if (!props.disabled) {
        // 递归过滤业务参数状态
        res.data = paramCodesDataFilter(res.data, 0)
      }
      paramCodeData.value = res.data
    }
  })
}
onMounted(() => {
  getByParamCodes()
})
// 去除数组null ''
const clear = (arr: any[], keys: string[]) => {
  if (!arr) {
    return []
  }
  let result: any = []
  arr.forEach((v: any) => {
    for (let i = 0; i < keys.length; i++) {
      const k = keys[i]
      if (v[k] != null && v[k] !== '') {
        result.push(v)
        break
      }
    }
  })
  if (!result.length) {
    result = [{}]
  }
  return result
}
// 点击暂存
const handleSaveToDraft = async () => {
  if (!form.value.customerName) {
    DcMessage.error(t('tips.customerEnterTips'))
    formRef.value?.validate('customerName')
    return
  }
  formRef.value?.validate('customerName').then(() => {
    DcConfirm.warning({
      cancelText: t('btn.cancel'),
      content: t('tips.saveOaDraft', {
        oaTypeStr: t('common.客户激活')
      }),
      okText: t('btn.sure'),
      onOk() {
        saveDraft()
      }
    })
  })
}
// 保存草稿
const saveDraft = async () => {
  loading.value = true
  const p = cloneDeep(form.value)
  p.skipReview = false
  if (p.business.businessTypeSelect) {
    p.business.businessType = [p.business.businessTypeSelect]
    p.business.businessTypeSelect = undefined
  }
  try {
    p.applyType = 2
    const data = await newClientEvaluationDraft(p, { custom: { errorMsg: false } })
    if (data.code === 200) {
      message.success(t('tips.saveSuccess'))
      goBack()
    } else {
      message.error(data.message)
    }
  } catch (error) {
  }
  loading.value = false
}
const handleSubmit = async () => {
  formRef.value?.validate().then(async () => {
    loading.value = true

    const p = cloneDeep(form.value)
    p.skipReview = false
    if (p.business.businessTypeSelect) {
      p.business.businessType = [p.business.businessTypeSelect]
      p.business.businessTypeSelect = undefined
    }
    try {
      // 这里判断是否再次提交评审id传进来，如果是空的那么一定是新增或者是草稿的详情
      if (queryAccountActivationId.value) {
        const data = await newClientEvaluationEdit(p)
        if (data.code === 200) {
          message.success(t('tips.activitySuccess'))
          goBack()
        } else {
          message.error(data.message)
        }
      } else {
        p.applyType = 2
        const data = await newClientEvaluationCreate(p, { custom: { errorMsg: false } })
        if (data.code === 200) {
          message.success(t('tips.addSuccess'))
          goBack()
        } else {
          message.error(data.message)
        }
      }
    } catch (error) {}
    loading.value = false
  })
}

// 新增列
const handleAddCol = (arr: {}[]) => {
  arr.push({})
}
// 删除列
const handleDelCol = (arr: {}[], index: number) => {
  arr.splice(index, 1)
}
</script>
<script lang="ts">
export default { name: 'accountActivationBaseMessage' }
</script>
